import B2becTranslation from '@/components/B2becTranslation'
import { NotificationManager } from '@/components/Notification'
import { SERVICE_ENTRY, SERVICE_TYPE } from '@/libs/constants'
import { isValidArray } from '@/libs/utils/array'
import { isObjectChecker } from '@/libs/utils/object'

const onCheckObjectHasEmptyValue = (object) => {
  return Object.values(object).some((value) => {
    if (isObjectChecker(value)) {
      return onCheckObjectHasEmptyValue(value)
    }
    return !value
  })
}

const onFilterObjectHasEmptyValue = (object) => {
  return Object.entries(object).filter(([key, value]) => {
    if (isObjectChecker(value)) {
      return onFilterObjectHasEmptyValue(value)
    }
    if (!value) {
      return { [key]: value }
    }
    return false
  })
}

export const onValidateFields = (
  form,
  tabIndex,
  serviceEntry,
  setCurrentTab,
) => {
  const contactPersonFields = [
    'contactPersonFirstName',
    'contactPersonLastName',
    'contactEmail',
    'contactNumber',
  ]
  const deliveryAddressFields = [
    ['deliveryAddress', 'name'],
    ['deliveryAddress', 'street'],
    ['deliveryAddress', 'zip'],
    ['deliveryAddress', 'city'],
    ['deliveryAddress', 'country'],
  ]
  const failureDescriptionFields = [
    'failureDescriptions',
    'failureDescriptionNotes',
  ]

  const validateFields = (fields) => {
    form
      .validateFields(fields)
      .then((response) => {
        const isDataNotFilled = onCheckObjectHasEmptyValue(response)

        if (isDataNotFilled) {
          NotificationManager.error({
            message: onFilterObjectHasEmptyValue(response).map(([key]) => {
              return (
                <span key={key} style={{ display: 'block' }}>
                  <B2becTranslation
                    value="form.validate.required"
                    variables={{ label: key }}
                  />
                </span>
              )
            }),
          })
        } else {
          setCurrentTab(+tabIndex)
        }
      })
      .catch((errorInfo) => {
        if (isValidArray(errorInfo?.errorFields)) {
          NotificationManager.error({
            message: errorInfo?.errorFields.map((error) => {
              return (
                <span key={error?.name.join('-')} style={{ display: 'block' }}>
                  {error?.errors}
                </span>
              )
            }),
          })
        }
      })
  }

  const validateContactInformationAndDeliveryAddressHandler = (
    nextTabIndex,
  ) => {
    if (+tabIndex >= nextTabIndex) {
      const deliveryAddress = form.getFieldValue('deliveryAddress')
      if (deliveryAddress?.isAddNew) {
        validateFields([...contactPersonFields, ...deliveryAddressFields])
      } else {
        validateFields(contactPersonFields)
      }
    } else {
      setCurrentTab(+tabIndex)
    }
  }

  const validateFailureDescriptionHandler = (nextTabIndex) => {
    if (+tabIndex >= nextTabIndex) {
      form
        .validateFields(failureDescriptionFields)
        .then((response) => {
          const FAQs = response?.failureDescriptions
          const FaqNotes = response?.failureDescriptionNotes
          if ((FAQs && FAQs.length > 0) || !!FaqNotes) {
            // Validate Address and Date Selection Step
            validateContactInformationAndDeliveryAddressHandler(
              nextTabIndex + 1,
            )
          } else {
            NotificationManager.error({
              message: 'form.validate.failureDescriptionRequired',
            })
          }
        })
        .catch((_) => {
          NotificationManager.error({
            message: 'form.validate.failureDescriptionRequired',
          })
        })
    } else {
      setCurrentTab(+tabIndex)
    }
  }

  switch (serviceEntry) {
    /*
      REPAIR (4 tabs)
        failure: 2
        contact: 3
      MACHINE (3 tabs)
        failure: 1
        contact: 2
      MAINTENANCE (3 tabs)
        contact: 2
    */
    case SERVICE_ENTRY.REPAIR: {
      // Validate Service Selection Step => then Address and Date Selection Step
      validateFailureDescriptionHandler(3)
      break
    }
    case SERVICE_ENTRY.MACHINE: {
      const selectedService = form.getFieldValue('serviceType')

      if (selectedService === SERVICE_TYPE.MAINTENANCE) {
        // ONLY validate Address and Date Selection Step (no service selection required)
        validateContactInformationAndDeliveryAddressHandler(3)
      } else {
        // Validate Service Selection Step => then Address and Date Selection Step
        validateFailureDescriptionHandler(2)
      }
      break
    }
    case SERVICE_ENTRY.MAINTENANCE: {
      // ONLY validate Address and Date Selection Step (no service selection required)
      validateContactInformationAndDeliveryAddressHandler(3)
      break
    }
    default: {
      break
    }
  }
}
